import gql from 'graphql-tag';
import { DocumentAttachmentFragments } from './document-attachment.fragments';

export class DocumentAttachmentQueries {
  static load = gql`
    query DocumentAttachments($documentId: String!) {
      document(documentId: $documentId) {
        id
        documentAttachments {
          ...documentAttachmentFragment
        }
      }
    }
    ${DocumentAttachmentFragments.documentAttachment}
  `;
}
